import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { UtilityNav } from 'web-ui-components/lib/navigation/site-navs';
import { UtilityNavButton } from 'web-ui-components/lib/navigation/site-navs';
import { HelpModal } from '../HelpModal/HelpModal';
import { GDPRExitModal } from '../GDPRExitModal/GDPRExitModal';
import { ROUTE_TECHNICAL_ERROR_PAGE } from '../../utils/constants';
import { redirectToBackScreen, toggleGDPRModal } from '../../store/dataCapture/actions';

const UtilityNavigation = ({ history }) => {
  const dispatch = useDispatch();
  const { pathName, isGDPRModel } = useSelector((state) => ({
    pathName: state.router.location.pathname,
    isGDPRModel: state.dataCapture.get('isOpen')
  }));
  const [isHelpModalOpen, toggleHelpModal] = useState(false);
  const isBackNavigationNeeded = pathName !== ROUTE_TECHNICAL_ERROR_PAGE;

  const handleToggle = () => toggleHelpModal(!isHelpModalOpen);
  const handleBackClick = () => {
    dispatch(redirectToBackScreen(pathName, isGDPRModel, history));
  };
  const handleGDPRModelToggle = (isOpen) => {
    dispatch(toggleGDPRModal(isOpen));
  };

  return (
    <>
      <UtilityNav
        leftContent={isBackNavigationNeeded && <UtilityNavButton.Back onClick={handleBackClick} />}
        rightContent={<UtilityNavButton.Help onClick={handleToggle} />}
      />
      {isHelpModalOpen && <HelpModal toggleHelpModal={handleToggle} />}
      {isGDPRModel && (
        <GDPRExitModal backClick={handleBackClick} toggleModel={handleGDPRModelToggle} />
      )}
    </>
  );
};

export { UtilityNavigation };
